<template>
  <div class="wrap"></div>
</template>

<script>
  import { Toast } from 'vant';
  import { validatenull, isvalidatemobile } from "@/util/validate";
  import { getEmpInfoByLinkCode, sendCheckCode, userCodeLogonNew } from '@/api/mobile/mobile'

  export default {
    data() {
      return {
        linkCode: ''
      }
    },
    created() {
      const { tid } = this.$route.params
      const filterTids = ['bjhpa','ciicpt']
      const isSpecialCus = filterTids.includes(tid)
      const path = isSpecialCus ? `/mobile/login/${ tid }` : '/mobile/login'
      this.linkCode = tid
      localStorage.setItem('linkCode', this.linkCode)
      localStorage.removeItem('empInfo')
      localStorage.removeItem('baseDataId')
      localStorage.removeItem('baseDataName')
      if(isSpecialCus || validatenull(this.hasToken)) {
        this.$router.push({
          path
        })
      } else {
        this.$router.push({
          name: 'AuthorizationLogin'
        })
      }
    },
    computed: {
      hasToken(){
        return !validatenull(localStorage.getItem('token'))
      }
    }
  }
</script>

<style lang="scss" scoped>
  .wrap{
    position: relative;
    color: #666666;
    overflow-y: auto;
    height: 100%;
  }
</style>
